import http from '@/libs/http/index'
const basePath = '/xxxx-admin/'
export default {

 login(params: { phone: string; vcode?: string }) {
    return Promise.resolve({ code: 200, msg: 'success', data: 'xxxxxxxx' })
  },
  logout() {
    return Promise.resolve({ code: 200, msg: 'success' })
  },
  getUserInfo() {
    return Promise.resolve({})
  },
}
